var map = {
	"./0.png": "642f",
	"./1.png": "dba4",
	"./2.png": "1fd0",
	"./3.png": "1fdf",
	"./4.png": "1835",
	"./5.png": "6fe1",
	"./6.png": "fad1",
	"./7.png": "ff94",
	"./8.png": "34f6",
	"./9.png": "acd0",
	"./x.png": "6174"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f688";